(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["image"] && !Shopify.designMode) return;
  try {
    // Advanced lazy loading with Intersection Observer
  class LazyImageLoader {
    constructor() {
      this.imageObserver = null;
      this.init();
    }

    init() {
      // Check if Intersection Observer is supported
      if ('IntersectionObserver' in window) {
        this.imageObserver = new IntersectionObserver((entries, observer) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              this.loadImage(entry.target);
              observer.unobserve(entry.target);
            }
          });
        }, {
          rootMargin: '50px 0px', // Start loading 50px before image enters viewport
          threshold: 0.01
        });

        // Observe all lazy images
        document.querySelectorAll('img[data-lazy]').forEach(img => {
          this.imageObserver.observe(img);
        });
      } else {
        // Fallback for browsers without Intersection Observer
        this.loadAllImages();
      }
    }

    loadImage(img) {
      // Load the high-quality image
      if (img.dataset.src) {
        img.src = img.dataset.src;
      }

      // Load srcset if available
      if (img.dataset.srcset) {
        img.srcset = img.dataset.srcset;
      }

      // Remove data attributes to prevent reloading
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
      img.removeAttribute('data-lazy');

      // Add loaded class when image loads
      img.addEventListener('load', () => {
        img.classList.add('loaded');
      });

      // Handle load errors
      img.addEventListener('error', () => {
        console.warn('Failed to load image:', img.src);
        img.classList.add('loaded'); // Still remove blur effect
      });
    }

    loadAllImages() {
      // Fallback: load all images immediately
      document.querySelectorAll('img[data-lazy]').forEach(img => {
        this.loadImage(img);
      });
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new LazyImageLoader();
    });
  } else {
    new LazyImageLoader();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["newsletter-signup"] && !Shopify.designMode) return;
  try {
    // Newsletter form handling
  document.addEventListener('DOMContentLoaded', function() {
    const newsletterForm = document.querySelector('.newsletter-signup form[action*="/contact"]');
    if (newsletterForm) {
      // Check if we're on a page with newsletter success message
      const urlParams = new URLSearchParams(window.location.search);
      const newsletterStatus = urlParams.get('newsletter');
      
      if (newsletterStatus === 'success') {
        // Show success message
        const successMessage = document.querySelector('.newsletter-signup__message--success');
        if (successMessage) {
          successMessage.style.display = 'block';
          successMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
        // Clear the form
        const emailInput = newsletterForm.querySelector('.newsletter-form__email');
        if (emailInput) emailInput.value = '';
        
        // Clean up URL to remove the parameter
        const newUrl = window.location.pathname;
        window.history.replaceState({}, document.title, newUrl);
      }
      
      // Add loading state to form submission
      newsletterForm.addEventListener('submit', function() {
        const submitButton = this.querySelector('.newsletter-form__submit');
        if (submitButton) {
          submitButton.disabled = true;
          submitButton.textContent = 'Subscribing...';
        }
      });
    }
  });
  } catch(e) { console.error(e); }
})();

})();
